import React from 'react'

import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Modal, Button, Link } from 'antd';

import CreateAccount from './create-account'
import CloudAccountFilterContainer from '../../containers/cloud-account-filter-container'
import CloudAccountListContainer from '../../containers/cloud-account-list-container'

import AmazonS3Logo from '../../assets/logo/partner-logo-Amazon.svg'
import WasabiLogo from '../../assets/logo/partner-logo-Wasabi.svg'
import AzureLogo from '../../assets/logo/partner-logo-Azure.svg'
import BackblazeLogo from '../../assets/logo/partner-logo-BackBlaze.svg'
import GenericS3Logo from '../../assets/logo/genericS3.svg'

import './styles.scss';

class CloudProviders extends React.Component {
    constructor(props) {
        super(props)

        let defaultProviders = [
            {
                img: AmazonS3Logo,
                name: 'aws',
                style: {
                    height: '38px',
                },
            },
            {
                img: WasabiLogo,
                name: 'wasabi',
                style: {
                    height: '38px',
                },
            },
            {
                img: AzureLogo,
                name: 'azure',
                style: {
                    height: '38px',
                },
            },
            {
                img: BackblazeLogo,
                name: 'backblaze',
                style: {
                    height: '38px'
                }
            },
            {
                img: GenericS3Logo,
                name: 'genericS3',
                style: {
                    height: '38px'
                }
            }
            
        ]
        let { referrer_id } = props
        if (referrer_id === 1) {
            defaultProviders = defaultProviders
                .concat
                /*[
          {
            img: AzureLogo,
            name: 'azure',
            style: {
              height: '38px'
            }
          },
          {
            img: GoogleCloudLogo,
            name: 'google'
          },
          {
            img: QumuloLogo,
            name: 'qumulo'
          },
          {
            img: ZadaraLogo,
            name: 'zadara'
          }
        ]*/
                ()
        }

        this.state = {
            providers: defaultProviders,
        }
    }

    componentDidMount() {
        const { match } = this.props
        let user = JSON.parse(localStorage.getItem('user')) || {
            bypass_onboard: true,
        }
        /* user.bypass_onboard = false */
        if (!user.bypass_onboard) {
            Modal.success({
                //title: 'Thank You',
                okText: "Let's get started",
                wrapClassName: 'modal_onboard',
                className: 'modal_onboard',
                maskClosable: true,
                onOk: () => {},
                content: (
                    <div className={'description-text'}>
                        <h1>Welcome to CloudFlyer!</h1>
                        <p>
                            We're going to help you manage your videos, files,
                            costs <br />
                            and cloud storage so much better!
                        </p>
                        <p className={'steps'}>
                            1) Simply enter your public cloud account
                            credentials. <br />
                            2) Name your account. <br />
                            3) Follow the steps to enable your billing
                            information. <br />
                            4) Download ftX client to move your data faster than
                            ever!
                        </p>
                        <p>
                            Within seconds you will have access to each account{' '}
                            <br />
                            and can start managing + moving your data sets from
                            a single page.
                        </p>
                        <p>
                            <b>
                                Security and data protection is paramount to
                                everyone!
                            </b>
                            <p>
                                We have designed a security architecture that
                                encrypts and protects our users
                                <br />
                                from any exposure at all times.
                            </p>
                        </p>
                    </div>
                ),
            })
            user.bypass_onboard = true
            localStorage.setItem('user', JSON.stringify(user))
        }
    }

    on_show_compare = () => {
        const { history } = this.props
        history.push('/cloud-compare/0')
    }

    render() {
        const { providers } = this.state
        const { match } = this.props
        return (
            <div className="cloud-provider-page">
                <div className="provider-header-nav">
                    <h2>Cloud Providers</h2>
                    {/* <CreateAccount providers={providers} /> */}

                    <CloudAccountFilterContainer
                        on_show_compare={this.on_show_compare}
                    />
                    <Button
                        href="/addProvider/wasabi"
                        type="primary"
                        className="new-provider-btn"
                        // onClick={() => {
                        //     on_save(this.handleSave)
                        // }}
                        >
                        New Provider
                    </Button>
                </div>
                <CloudAccountListContainer />
            </div>
        )
    }
}

export default withRouter(
    connect(
        ({ auth }, { match, history }) => {
            let user = auth.user
            return {
                ...user,
            }
        },
        dispatch => bindActionCreators({}, dispatch)
    )(CloudProviders)
)
